import { PayCorrectionEmployeeItem } from 'apps/sigma2-ui/src/pay-correction/components/PayCorrectionTable';
import { isPayCorrectionEmployeeNeedsAttention } from 'apps/sigma2-ui/src/pay-correction/libs/isPayCorrectionEmployeeNeedsAttention';

export const usePayCorrectionNeedsAttentionEmployees = ({
  listItems,
}: {
  listItems: PayCorrectionEmployeeItem[];
}) => {
  return listItems.filter((item) => {
    return isPayCorrectionEmployeeNeedsAttention({ item });
  });
};
